export default function generateClassName(config = {}) {
    const nameClass = config.name ? ` butter-toast-${config.name}` : '';

    return `butter-toast-tray${nameClass} ${config.trayPosition || ''}`.trim();
}


// WEBPACK FOOTER //
// ./src/ButterToast/helpers/generate_class_name/index.js